module.exports = __webpack_public_path__ + "static/media/user.ff22a7d1.png";